export const content = {
  location: [
    {
      place: "None",
    },
    {
      place: "Bangalore",
    },
  ],
  status: [
    {
      name: "None",
    },
    {
      name: "Pending",
    },
  ],
  documentType: [
    {
      name: "Sales Deed",
    },
    {
      name: "Property Tax",
    },
    {
      name: "EC",
    },
    {
      name: "Others",
    },
  ],
columnSite: [
  {
    id: "state",
    numeric: false,
    disablePadding: false,
    label: "State",
    width: "18%",
  },
  {
    id: "location_name",
    numeric: false,
    disablePadding: false,
    label: "Location",
    width: "18%",
  },
  {
    id: "name",
    numeric: false,
    disablePadding: false,
    label: "Site",
    width: "15%",
  },
  {
    id: "site_type",
    numeric: false,
    disablePadding: false,
    label: "Site Type",
    width: "10%",
  },
  {
    id: "property_tax_applicability",
    numeric: false,
    disablePadding: false,
    label: "Property Tax Applicability",
    width: "14%",
  },
  {
    id: "description",
    numeric: false,
    disablePadding: false,
    label: "Site Description",
    width: "15%",
  },
  {
    id: "actions",
    label: "Action",
    disableSorting: true,
    width: "10%",
  },
],
  surveySite: [
    {
      id: "site_name",
      numeric: false,
      disablePadding: false,
      label: "Site",
      width: "14.28%",
    },
    {
      id: "unique_survey_no",
      numeric: false,
      disablePadding: false,
      label: "Unique Survey Number",
      width: "14.28%",
    },
    {
      id: "acre",
      numeric: false,
      disablePadding: false,
      label: "Area in Acres",
      width: "14.28%",
    },
    {
      id: "gunta",
      numeric: false,
      disablePadding: false,
      label: "Area in Guntas",
      width: "14.28%",
    },
    {
      id: "karab_land_acre",
      numeric: false,
      disablePadding: false,
      label: "Kharab in Acres",
      width: "14.28%",
    },
    {
      id: "karab_land_gunta",
      numeric: false,
      disablePadding: false,
      label: "Kharab in Gunta",
      width: "14.28%",
    },
    { id: "actions", label: "Action", disableSorting: true, width: "14.28%" },
  ],
  courtLitigation: [
    {
      id: "site_name",
      numeric: false,
      disablePadding: false,
      label: "Site",
      width: "8.33%",
    },
    {
      id: "case_type", // ✅ EXACT MATCH
      numeric: false,
      disablePadding: false,
      label: "Case Type",
      width: "8.33%",
    },
    {
      id: "os_number",
      numeric: false,
      disablePadding: false,
      label: "Original Suite No",
      width: "8.33%",
    },
     {
      id: "cnr_number",
      numeric: false,
      disablePadding: false,
      label: "CNR Number",
      width: "2%",
    },
    {
      id: "unique_survey_no",
      numeric: false,
      disablePadding: false,
      label: "Unique Survey Number",
      width: "8.33%",
    },
       {
      id: "stage",
      numeric: false,
      disablePadding: false,
      label: "Court Stage",
      width: "2%",
    },
    {
      id: "status",
      numeric: false,
      disablePadding: false,
      label: "Current Status",
      width: "8.33%",
    },
    {
      id: "summary",
      numeric: false,
      disablePadding: false,
      label: "Summary",
      width: "12.99%",
    },
    {
      id: "os_date",
      numeric: false,
      disablePadding: false,
      label: "Original Suite Date",
      width: "8.33%",
    },
    {
      id: "area_under_litigation_acre",
      numeric: false,
      disablePadding: false,
      label: "Area In Acre",
      width: "5",
    },
    {
      id: "area_under_litigation_gunta",
      numeric: false,
      disablePadding: false,
      label: "Area In Gunta",
      width: "5",
    },
    {
      id: "foundation_role",
      numeric: false,
      disablePadding: false,
      label: "Foundation Role",
      width: "8.33%",
    },
    {
      id: "next_hearing_date",
      numeric: false,
      disablePadding: false,
      label: "Next Hearing Date",
      width: "8.33%",
    },
    {
      id: "closure_date",
      numeric: false,
      disablePadding: false,
      label: "Closure Date",
      width: "8.33%",
    },
    { id: "actions", label: "Action", disableSorting: true, width: "8.33%" },
  ],
  historyTrack: [
    {
      id: "old_status",
      numeric: false,
      disablePadding: false,
      label: "Old Status",
      width: "25%",
    },
    {
      id: "new_status",
      numeric: false,
      disablePadding: false,
      label: "New Status",
      width: "25%",
    },
    {
      id: "updated_by",
      numeric: false,
      disablePadding: false,
      label: "Updated By",
      width: "25%",
    },
    {
      id: "updated_at",
      numeric: false,
      disablePadding: false,
      label: "Updated At",
      width: "25%",
    },
  ],
  building: [
    {
      id: "state",
      numeric: false,
      disablePadding: false,
      label: "State",
      width: "16.66%",
    },
    {
      id: "location",
      numeric: false,
      disablePadding: false,
      label: "Location",
      width: "16.66%",
    },
    {
      id: "site",
      numeric: false,
      disablePadding: false,
      label: "Site",
      width: "16.66%",
    },
    {
      id: "building_name",
      numeric: false,
      disablePadding: false,
      label: "Building Name",
      width: "16.66%",
    },
    { id: "actions", label: "Action", disableSorting: true, width: "16.66%" },
  ],
  rowsite: [
    {
      id: "1",
      state: "Karnataka",
      site: "APU",
      location: "Bangalore",
      survey: "77,57",
      date: "21/03/25",
    },
    {
      id: "2",
      state: "Karnataka",
      site: "APU",
      location: "Bangalore",
      survey: "77",
      date: "18/03/25",
    },
    {
      id: "3",
      state: "Karnataka",
      site: "APU",
      location: "Bangalore",
      survey: "77,57",
      date: "16/03/25",
    },
    {
      id: "4",
      state: "Karnataka",
      site: "APU",
      location: "Bangalore",
      survey: "77,57",
      date: "08/03/25",
    },
    {
      id: "5",
      state: "Karnataka",
      site: "APU",
      location: "Bangalore",
      survey: "77",
      date: "06/03/25",
    },
  ],
  columnUpload: [
    {
      id: "document_name",
      numeric: false,
      disablePadding: false,
      label: "File Name",
      width: "10%",
    },
    {
      id: "state_name",
      numeric: false,
      disablePadding: false,
      label: "State",
      width: "10%",
    },
    {
      id: "location_name",
      numeric: false,
      disablePadding: false,
      label: "Location",
      width: "10%",
    },
    {
      id: "site_name",
      numeric: false,
      disablePadding: false,
      label: "Site",
      width: "10%",
    },
    {
      id: "uploaded_at",
      numeric: false,
      disablePadding: false,
      label: "Created Date",
      width: "10%",
    },
    {
      id: "document_category",
      numeric: false,
      disablePadding: false,
      label: "Document Category",
      width: "10%",
    },
    {
      id: "document_type",
      numeric: false,
      disablePadding: false,
      label: "Document Type",
      width: "10%",
    },
    {
      id: "approval_status",
      numeric: false,
      disablePadding: false,
      label: "Status",
      width: "10%",
    },
    {
      id: "comments",
      numeric: false,
      disablePadding: false,
      label: "Comments",
      width: "10%",
      renderCell: (params) => (
        <div
          style={{
            whiteSpace: "normal",
            wordWrap: "break-word",
            lineHeight: "1.2",
            overflowWrap: "break-word",
            paddingTop: "4px",
            paddingBottom: "4px",
          }}
        >
          {params.value}
        </div>
      ),
    },
    {
      id: "action",
      numeric: false,
      disablePadding: false,
      label: "Action",
      width: "10%",
    },
  ],
  rowUpload: [
    {
      file: "1_BLR_APU_SD_4796",
      state: "Karnataka",
      date: "21/03/25",
      category: "Sales Deed",
      status: "Pending",
      comment: "-",
      action: "",
    },
    {
      file: "1_BLR_APU_SD_4796",
      state: "Karnataka",
      date: "18/03/25",
      category: "Sales Deed",
      status: "Rejected",
      comment:
        "Incorrect Document Uploaded or Clarity of the uploaded document is not good",
      action: "",
    },

    {
      id: "10",
      file: "1_BLR_APU_SD_4796",
      state: "Karnataka",
      date: "06/03/25",
      category: "property Tax",
      status: "Accepted",
      comment: "-",
      action: "",
    },
  ],
  files: [
    {
      state: "Karnataka",
      city: [
        {
          name: "Bangalore",
          site: [
            {
              name: "Site 01",
            },
            {
              name: "Site 02",
            },
            {
              name: "Site 03",
            },
          ],
          tableRow: [
            {
              id: "1",
              file: "1_BLR_APU_SD_4796",
              date: "21/03/25",
              site: "APU",
              entity: "Azim Premji Trust",
              category: "Land Acquistion",
              survey: "77",
              box: "1",
              type: "Sales Deed",
            },
            {
              id: "2",
              file: "1_BLR_APU_ECC_4796",
              date: "18/03/25",
              site: "APU",
              entity: "Azim Premji Trust",
              category: "Land Acquistion",
              survey: "77",
              box: "1",
              type: "ECC",
            },
            {
              id: "3",
              file: "1_BLR_APU_CO_4796",
              date: "16/03/25",
              site: "APU",
              entity: "Azim Premji Trust",
              category: "Land Acquistion",
              survey: "77",
              box: "1",
              type: "Conversion Order",
            },
            {
              id: "4",
              file: "1_BLR_APU_CS_4796",
              date: "08/03/25",
              site: "APU",
              entity: "Azim Premji Trust",
              category: "Land Acquistion",
              survey: "77",
              box: "1",
              type: "Conversion Sketch",
            },
            {
              id: "5",
              file: "1_BLR_APU_NOC_4796",
              date: "06/03/25",
              site: "APU",
              entity: "Azim Premji Trust",
              category: "Land Acquistion",
              survey: "77",
              box: "1",
              type: "NOC",
            },
          ],
        },
        {
          name: "Mysore",
          site: [
            {
              name: "Site 01",
            },
            {
              name: "Site 02",
            },
            {
              name: "Site 03",
            },
          ],
          tableRow: [
            {
              id: "1",
              file: "1_BLR_APU_SD_4796",
              date: "21/03/25",
              site: "APU",
              entity: "Azim Premji Trust",
              category: "Land Acquistion",
              survey: "77",
              box: "1",
              type: "Sales Deed",
            },
            {
              id: "2",
              file: "1_BLR_APU_ECC_4796",
              date: "18/03/25",
              site: "APU",
              entity: "Azim Premji Trust",
              category: "Land Acquistion",
              survey: "77",
              box: "1",
              type: "ECC",
            },
            {
              id: "3",
              file: "1_BLR_APU_CO_4796",
              date: "16/03/25",
              site: "APU",
              entity: "Azim Premji Trust",
              category: "Land Acquistion",
              survey: "77",
              box: "1",
              type: "Conversion Order",
            },
            {
              id: "4",
              file: "1_BLR_APU_CS_4796",
              date: "08/03/25",
              site: "APU",
              entity: "Azim Premji Trust",
              category: "Land Acquistion",
              survey: "77",
              box: "1",
              type: "Conversion Sketch",
            },
            {
              id: "5",
              file: "1_BLR_APU_NOC_4796",
              date: "06/03/25",
              site: "APU",
              entity: "Azim Premji Trust",
              category: "Land Acquistion",
              survey: "77",
              box: "1",
              type: "NOC",
            },
          ],
        },
        {
          name: "Kolar",
          site: [
            {
              name: "Site 01",
            },
            {
              name: "Site 02",
            },
            {
              name: "Site 03",
            },
          ],
          tableRow: [
            {
              id: "1",
              file: "1_BLR_APU_SD_4796",
              date: "21/03/25",
              site: "APU",
              entity: "Azim Premji Trust",
              category: "Land Acquistion",
              survey: "77",
              box: "1",
              type: "Sales Deed",
            },
            {
              id: "2",
              file: "1_BLR_APU_ECC_4796",
              date: "18/03/25",
              site: "APU",
              entity: "Azim Premji Trust",
              category: "Land Acquistion",
              survey: "77",
              box: "1",
              type: "ECC",
            },
            {
              id: "3",
              file: "1_BLR_APU_CO_4796",
              date: "16/03/25",
              site: "APU",
              entity: "Azim Premji Trust",
              category: "Land Acquistion",
              survey: "77",
              box: "1",
              type: "Conversion Order",
            },
            {
              id: "4",
              file: "1_BLR_APU_CS_4796",
              date: "08/03/25",
              site: "APU",
              entity: "Azim Premji Trust",
              category: "Land Acquistion",
              survey: "77",
              box: "1",
              type: "Conversion Sketch",
            },
            {
              id: "5",
              file: "1_BLR_APU_NOC_4796",
              date: "06/03/25",
              site: "APU",
              entity: "Azim Premji Trust",
              category: "Land Acquistion",
              survey: "77",
              box: "1",
              type: "NOC",
            },
          ],
        },
      ],
    },
    {
      state: "Delhi",
      city: [
        {
          name: "",
          site: [
            {
              name: "Site 01",
            },
            {
              name: "Site 02",
            },
            {
              name: "Site 03",
            },
          ],
          tableRow: [
            {
              id: "1",
              file: "1_BLR_APU_SD_4796",
              date: "21/03/25",
              site: "APU",
              entity: "Azim Premji Trust",
              category: "Land Acquistion",
              survey: "77",
              box: "1",
              type: "Sales Deed",
            },
            {
              id: "2",
              file: "1_BLR_APU_ECC_4796",
              date: "18/03/25",
              site: "APU",
              entity: "Azim Premji Trust",
              category: "Land Acquistion",
              survey: "77",
              box: "1",
              type: "ECC",
            },
            {
              id: "3",
              file: "1_BLR_APU_CO_4796",
              date: "16/03/25",
              site: "APU",
              entity: "Azim Premji Trust",
              category: "Land Acquistion",
              survey: "77",
              box: "1",
              type: "Conversion Order",
            },
            {
              id: "4",
              file: "1_BLR_APU_CS_4796",
              date: "08/03/25",
              site: "APU",
              entity: "Azim Premji Trust",
              category: "Land Acquistion",
              survey: "77",
              box: "1",
              type: "Conversion Sketch",
            },
            {
              id: "5",
              file: "1_BLR_APU_NOC_4796",
              date: "06/03/25",
              site: "APU",
              entity: "Azim Premji Trust",
              category: "Land Acquistion",
              survey: "77",
              box: "1",
              type: "NOC",
            },
          ],
        },
      ],
    },
  ],
  tableColumn: [
    {
      id: "document_name",
      numeric: false,
      disablePadding: false,
      label: "File Name",
      width: "14.3%",
    },
    {
      id: "uploaded_at",
      numeric: false,
      disablePadding: false,
      label: "Created Date",
      width: "14.2%",
    },
    {
      id: "site_name",
      numeric: false,
      disablePadding: false,
      label: "Site",
      width: "14.3%",
    },
    {
      id: "document_category",
      numeric: false,
      disablePadding: false,
      label: "Document Category",
      width: "14.3%",
    },
    {
      id: "document_type",
      numeric: false,
      disablePadding: false,
      label: "Document Type",
      width: "14.3%",
    },
    // {id: 'box_number', numeric: false, disablePadding: false, label: 'Box No.', width: '12.5%'},
    {
      id: "os_number",
      numeric: false,
      disablePadding: false,
      label: "O/S Number",
      width: "14.3%",
    },
    {
  id: "approved_by",
  numeric: false,
  disablePadding: false,
  label: "Approved By",
  width: "14.3%",
},
    {
      id: "action",
      numeric: false,
      disablePadding: false,
      label: "Action",
      width: "14.3%",
    },
  ],
  rejected: [
    {
      id: "document_name",
      numeric: false,
      disablePadding: false,
      label: "File Name",
      width: "20%",
    },
    {
      id: "state_name",
      numeric: false,
      disablePadding: false,
      label: "State",
      width: "20%",
    },
    {
      id: "location_name",
      numeric: false,
      disablePadding: false,
      label: "Location",
      width: "20%",
    },
    {
      id: "site_name",
      numeric: false,
      disablePadding: false,
      label: "Site",
      width: "20%",
    },
    {
      id: "uploaded_by",
      numeric: false,
      disablePadding: false,
      label: "Uploaded By",
      width: "10%",
    },

    {
      id: "approved_rejected_at",
      numeric: false,
      disablePadding: false,
      label: "Rejeceted Date",
      width: "10%",
    },
  ],
  borrowed: [
    {
      id: "document_name",
      numeric: false,
      disablePadding: false,
      label: "File Name",
      width: "20%",
    },
    {
      id: "borrowal_date",
      numeric: false,
      disablePadding: false,
      label: "Date",
      width: "20%",
    },
    {
      id: "status",
      numeric: false,
      disablePadding: false,
      label: "Status",
      width: "20%",
    },
    {
      id: "borrowed_user",
      numeric: false,
      disablePadding: false,
      label: "Borrowed User",
      width: "10%",
    },
    {
      id: "uploaded_by",
      numeric: false,
      disablePadding: false,
      label: "Uploaded By",
      width: "10%",
    },

  ],
  approved: [
    {
      id: "document_name",
      numeric: false,
      disablePadding: false,
      label: "File Name",
      width: "20%",
    },
    {
      id: "state_name",
      numeric: false,
      disablePadding: false,
      label: "State",
      width: "20%",
    },
    {
      id: "location_name",
      numeric: false,
      disablePadding: false,
      label: "Location",
      width: "20%",
    },
    {
      id: "site_name",
      numeric: false,
      disablePadding: false,
      label: "Site",
      width: "20%",
    },
    {
      id: "uploaded_by",
      numeric: false,
      disablePadding: false,
      label: "Uploaded By",
      width: "10%",
    },

    {
      id: "approved_rejected_at",
      numeric: false,
      disablePadding: false,
      label: "Approved Date",
      width: "10%",
    },
  ],
  pending: [
    {
      id: "document_name",
      numeric: false,
      disablePadding: false,
      label: "File Name",
      width: "16.66%",
    },
    {
      id: "state_name",
      numeric: false,
      disablePadding: false,
      label: "State",
      width: "10%",
    },
    {
      id: "location_name",
      numeric: false,
      disablePadding: false,
      label: "Location",
      width: "10%",
    },
    {
      id: "site_name",
      numeric: false,
      disablePadding: false,
      label: "Site",
      width: "16.66%",
    },
    {
      id: "uploaded_at",
      numeric: false,
      disablePadding: false,
      label: "Uploaded Date",
      width: "5%",
    },
    {
      id: "uploaded_by",
      numeric: false,
      disablePadding: false,
      label: "Uploaded By",
      width: "5%",
    },
    { id: "actions", label: "Action", disableSorting: true, width: "26.64%" },
  ],
  accessManagerRows: [
    {
      username: "John D",
      role: "SPOC",
      date: "21/03/25",
      state: "Karnataka",
    },
    {
      username: "Emily R",
      role: "End User",
      date: "18/03/25",
      state: "KA/Bengaluru",
    },
    {
      username: "Arvind P",
      role: "End User",
      date: "18/03/25",
      state: "KA/Bengaluru",
    },
    {
      username: "Tom J",
      role: "SPOC",
      date: "08/03/25",
      state: "KA/Bengaluru/Sarjapur/Land_acquistion",
    },
    {
      username: "Carl S",
      role: "SPOC",
      date: "06/03/25",
      state: "Karnataka",
    },
  ],
  accessManagerHeadCells: [
    {
      id: "user_name",
      numeric: false,
      disablePadding: false,
      label: "Username",
      width: "14.28%",
    },
    {
      id: "state_name",
      numeric: false,
      disablePadding: false,
      label: "State",
      width: "14.28%",
    },
    {
      id: "location_name",
      numeric: false,
      disablePadding: false,
      label: "Location",
      width: "14.28%",
    },
    {
      id: "site_name",
      numeric: false,
      disablePadding: false,
      label: "Site",
      width: "14.28%",
    },
    {
      id: "category_name",
      numeric: false,
      disablePadding: false,
      label: "Document Category",
      width: "18.56%",
    },
    {
      id: "role_name",
      numeric: false,
      disablePadding: false,
      label: "Role",
      width: "10%",
    },
    {
      id: "created_at",
      numeric: false,
      disablePadding: false,
      label: "Created Date",
      width: "14.28%",
    },
    {
      id: "actions",
      numeric: true,
      disablePadding: false,
      label: "Action",
      width: "14.28%",
    },
  ],
  users: [
    {
      id: "first_name",
      numeric: false,
      disablePadding: false,
      label: "First Name",
      width: "20%",
    },
    {
      id: "last_name",
      numeric: false,
      disablePadding: false,
      label: "Last Name",
      width: "20%",
    },
    {
      id: "role",
      numeric: false,
      disablePadding: false,
      label: "Role",
      width: "20%",
    },
    {
      id: "email",
      numeric: false,
      disablePadding: false,
      label: "Email",
      width: "20%",
    },
    {
      id: "actions",
      numeric: true,
      disablePadding: false,
      label: "Action",
      width: "20%",
    },
  ],
};
